import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'uTCtoLocal'
})
export class UTCtoLocalPipe implements PipeTransform {
  constructor(private datepipe: DatePipe) {

  }

  newActivityDate: string;
  transform(value: any, covertToUTC: boolean): any {
    if (value !== null) {
      if (!covertToUTC) {
        var d = new Date(value); // val is in UTC
        var newActivityDate = this.datepipe.transform(d, "MM/dd/yyyy, hh:mm a");
        return newActivityDate;
      } else {
        var d = new Date(value); // val is in UTC
        var localOffset = new Date().getTimezoneOffset() * 60000;
        var localTime = d.getTime() - localOffset;
        d.setTime(localTime);
        var newActivityDate = this.datepipe.transform(d, "MM/dd/yyyy, hh:mm a");
        return newActivityDate;
      }
      // const datepipe: DatePipe = new DatePipe("locale");


    } else {
      return this.newActivityDate = '-';
    }

  }

}
